/**
 * UrlParams Utility Class.
 *
 * Abstracts parsing of current window url parameters.
 *
 */
// imports
import StringUtil from './string';

export type ParsedUrlParams = Record<string, Array<string>>;

/**
 * UrlParams Utility Class.
 */
export class UrlParams {
        

    public static getOneOf(keys: Array<string>, params: ParsedUrlParams) : Array<string> 
    {
        for(let i = 0; i < keys.length; i ++) {
            const key = keys[i];
            const result = UrlParams.get(key, params);
            if (result.length) {
                return result;
            }
        }
        return [];
    }

    public static get(key: string, params: ParsedUrlParams ) : Array<string> 
    {
        if (typeof(params[key]) === 'undefined') {
            return [];
        }
        return params[key];
    }

    /**
     * Parse the current url's parameters into an object.
     *
     * @return {Dictionary}
     */
    public static parse(): ParsedUrlParams
    {
        const params: Record<string, Array<string>> = {};
        const search = UrlParams.getWindowSearch().substring(1);
        const pairs = search.split('&');
        for (let i = 0; i < pairs.length; i++) {
            const pair = pairs[i];
            if (pair.indexOf('=') !== -1) {
                const pieces = pair.split('=');
                const key = StringUtil.ascii(pieces[0]);
                // handle multiple values provided
                const value = StringUtil.ascii(pieces[1]);
                const values = value.split(',');

                // save a lowercase version of the key as well
                // for reference
                if (typeof(params[key]) === 'undefined') {
                    params[key] = [];
                    if (key !== key.toLocaleLowerCase()) {
                        params[key.toLocaleLowerCase()] = [];
                    }
                }
                for (let j = 0; j < values.length; j ++) {
                    params[key].push(values[j]);
                    if (key !== key.toLocaleLowerCase()) {
                        params[key.toLocaleLowerCase()].push(values[j]);
                    }
                }
            }
        }
        return params;
    }

    /**
     * Getter that adds support for mocking the window search
     * (query string) for testing purposes.
     *
     * @return {tring}
     */
    protected static getWindowSearch(): string {
        if (typeof(window.__mock_window_search) === 'string') {
            return window.__mock_window_search;
        } else {
            return window.location.search;
        }
    }
}
